import React from "react";
import { connect } from "react-redux";

import Select from "react-select";
import { Row, Col, Card, CardBody, CardTitle, Input } from "reactstrap";
import { Tabs, Tab } from "react-bootstrap";
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";

import { obterUsuariosVinculadosAoMetrics } from "../actions/UsuarioActions";
import { obterPesquisasDeSatisfacao, obterPesquisasDeSatisfacaoPeloContrato, obterPesquisasDeSatisfacaoPeloPeriodo } from "../actions/ContratoActions";
import PieGraph from "../components/Graficos/Pie";
import DoughnutGraph from "../components/Graficos/Doughnut";
import BarGraph from "../components/Graficos/Bar";
import TablePublicacoes from "../components/TablePublicacoes";

const CARD = { display: "flex", flexDirection: "column" },
  CARDTITLE = { fontWeight: "600" },
  CARDNUMBER = { fontSize: 60, fontWeight: "bolder" },
  TAB = { backgroundColor: "#D9DEE6", padding: 20};

class PesquisaSatisfacao extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      tab: 1,
      selectUsuarios: [],
      usuarioSelecionado: [],
      periodoSelecionado: [],
      contrato: "",
      bordaAzul: false,
      notaAtendimento: { excelente: 0, otimo: 0, bom: 0, ruim: 0 }, 
      notaGeral: { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
      notaPaginacao: { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
      notaCapadura: { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
      countPublicacoes: { paginacao: 0, capaDura: 0 },
      periodoSelecionado: [],
      ignorarAlphaE: false,
      exibirGraficosPorDesigner: false,
      exibirGraficosPorContrato: false,
      exibirGraficosPorPeriodo: false,
      carregando: false,
      contratosAvaliados: 0
    }
  }

  async componentDidMount () {
    if (this.props.usuario.autenticado.email === "jessicasousa@alphaeditora.com.br" || this.props.usuario.autenticado.email === "atendimento01@alphaeditora.com.br" || this.props.usuario.autenticado.email === "teo@alphaeditora.com.br" || this.props.usuario.autenticado.email === "cristiano@alphaeditora.com.br") {
      await this.props.obterUsuariosVinculadosAoMetrics();
      if (this.props.usuario.todos) {
        let selectUsuarios = [{ value: 0, label: "Todos" }];
        this.props.usuario.todos.forEach((usuario) => {
          if (usuario.tipo === "comum") {
            selectUsuarios.push({ value: usuario.id, label: usuario.nome});
          }
        });
        selectUsuarios.sort((a, b) => a.label > b.label ? 1 : -1);
        this.setState({ selectUsuarios });
      } else {
        toast.error("Não foi possível carregar os designers. Atualize a tela e tente novamente!");
      }
    } else {
      this.props.history.push({pathname:"/unauthorized"});
    }
  }

  findPositionToChangeGrade (object, grade) {
    switch (grade) {
      case 1:
        object.ruim++;
        break;
      case 2: 
        object.bom++;
        break;
      case 3:
        object.otimo++;
        break;
      case 4: 
        object.excelente++;
        break;
    }
    return object;
  }

  async handleChangeTab () {
    await this.setState({
      contrato: "",
      bordaAzul: false,
      notaAtendimento: { excelente: 0, otimo: 0, bom: 0, ruim: 0 }, 
      notaGeral: { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
      countPublicacoes: { paginacao: 0, capaDura: 0 },
      exibirGraficosPorDesigner: false,
      exibirGraficosPorContrato: false,
      exibirGraficosPorPeriodo: false,
      carregando: false,
      contratosAvaliados: 0
    });
  }

  async alimentarVariaveisDeEstado () {
    if (this.props.contratos) {
      let notaGeral = {excelente: 0, otimo: 0, bom: 0, ruim: 0},
        notaAtendimento = {excelente: 0, otimo: 0, bom: 0, ruim: 0},
        notaPaginacao = { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
        notaCapadura = { excelente: 0, otimo: 0, bom: 0, ruim: 0 },
        countPublicacoes = {paginacao: 0, capaDura: 0};
      for (let i = 0; i < this.props.contratos.length; i++) {
        let contrato = this.props.contratos[i];
        for (let j = 0; j < contrato.publicacoes.length; j++) {
          let publicacao = contrato.publicacoes[j];
          if (publicacao.tipo === "Paginação") {
            notaGeral = await this.findPositionToChangeGrade(notaGeral, publicacao.pesquisas.notaDesign);
            notaAtendimento = await this.findPositionToChangeGrade(notaAtendimento, publicacao.pesquisas.notaAtendimento);
            notaPaginacao = await this.findPositionToChangeGrade(notaPaginacao, publicacao.pesquisas.notaAtendimento);
            notaPaginacao = await this.findPositionToChangeGrade(notaPaginacao, publicacao.pesquisas.notaDesign);
            countPublicacoes.paginacao++;
          } else {
            notaGeral = await this.findPositionToChangeGrade(notaGeral, publicacao.pesquisas.notaDesign);
            notaCapadura = await this.findPositionToChangeGrade(notaCapadura, publicacao.pesquisas.notaDesign);
            countPublicacoes.capaDura++;
          }
        }
      }
      this.setState({notaAtendimento, notaGeral, notaPaginacao, notaCapadura, contratosAvaliados: this.props.contratos.length, countPublicacoes});
    }
  }

  async handleChangeDesigner (designer) {
    this.setState({exibirGraficosPorDesigner: false, carregando: true, usuarioSelecionado: designer});
    await this.props.obterPesquisasDeSatisfacao(designer.value);
    await this.alimentarVariaveisDeEstado();
    this.setState({exibirGraficosPorDesigner: true, carregando: false});
  }

  async handleChangeTipo (e) {
    this.setState({exibirGraficosPorContrato: false, carregando: true});
    if (this.state.contrato) {
      await this.props.obterPesquisasDeSatisfacaoPeloContrato(this.state.contrato);
      this.setState({exibirGraficosPorContrato: true, carregando: false});
    }
  }

  async handleChangePeriodo () {
    let datas = [],
      { periodoSelecionado, usuarioSelecionado, ignorarAlphaE } = this.state;
    
    if (periodoSelecionado.length === 2 && usuarioSelecionado) {
      this.setState({exibirGraficosPorPeriodo: false, carregando: true});
      periodoSelecionado.forEach((data) => {
        let dataPreparada = new Date(data).toLocaleDateString("pt-br", {timezome: "UTC"});
        dataPreparada = dataPreparada.split("/").reverse().join("-");
        datas.push(dataPreparada);
      });
      await this.props.obterPesquisasDeSatisfacaoPeloPeriodo(datas, usuarioSelecionado, ignorarAlphaE);
      await this.alimentarVariaveisDeEstado();
      this.setState({exibirGraficosPorPeriodo: true, carregando: false});
    } else {
      await this.handleChangeTab();
    }
  }

  render () {
    return (
      <div>
        <Tabs id="tabsDashboardPesquisa" defaultActiveKey="tabPorDesigner">
          <Tab eventKey="tabPorDesigner" title="Pesquisar por designer" style={TAB}>
            <Row>
              <Col md="3" sm="12">
                <Select name="selectUsuarios" options={this.state.selectUsuarios} onChange={this.handleChangeDesigner.bind(this)} placeholder="Digite o nome do designer"/>
              </Col>
              <Col md="1">{this.state.carregando ? <i className="fa fa-spinner fa-pulse fa-2x"/> : null}</Col>
            </Row>
            {
              !this.state.exibirGraficosPorDesigner ?
                null
              : 
              <div>
                <br/>
                <Row>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Contratos avaliados</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.contratosAvaliados}</CardBody>
                    </Card>
                  </Col>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Capas avaliadas</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.countPublicacoes.capaDura}</CardBody>
                    </Card>
                  </Col>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Paginações avaliadas</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.countPublicacoes.paginacao}</CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de layout (capa e miolo)</CardTitle>
                      <CardBody><PieGraph data={this.state.notaGeral}/></CardBody>
                    </Card>
                  </Col>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de atendimento</CardTitle>
                      <CardBody><PieGraph data={this.state.notaAtendimento}/></CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de paginação</CardTitle>
                      <CardBody><DoughnutGraph data={this.state.notaPaginacao}/></CardBody>
                    </Card>
                  </Col>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de capa dura</CardTitle>
                      <CardBody><DoughnutGraph data={this.state.notaCapadura}/></CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <TablePublicacoes contratos={this.props.contratos} isContract={true} designer={this.state.usuarioSelecionado.label}/>
                  </Col>
                </Row>              
              </div>
            }
          </Tab>
          <Tab eventKey="tabPorContrato" title="Pesquisar por contrato" style={TAB}>
            <Row>
              <Col md="3">
                <Input 
                  type="number" 
                  style={{backgroundColor: "white", borderRadius: 4, border: `${this.state.bordaAzul ? "2px solid #2684FF" : "1px solid #CCCCCC"}`}} 
                  onFocus={() => {this.setState({bordaAzul: true})}} 
                  onBlur={() => {this.setState({bordaAzul: false})}} 
                  placeholder="30047" value={this.state.contrato} 
                  onChange={(e) => {this.setState({contrato: e.target.value})}} 
                  onKeyDown={(e) => {e.keyCode === 13 ? this.handleChangeTipo() : null}}
                />
              </Col>
              <Col md="1">{this.state.carregando ? <i className="fa fa-spinner fa-pulse fa-2x"/> : null}</Col>
            </Row>
            {
              !this.state.exibirGraficosPorContrato ?
                null
              : this.props.contratos[0] ?
                <div>
                  <br/>
                  <BarGraph publicacoes={this.props.contratos[0].publicacoes}/>
                  <br/>
                  <TablePublicacoes contratos={this.props.contratos[0].publicacoes} isContract={false}/>
                </div>
              : <div><br/>Não existem publicações avaliadas e/ou cadastradas!</div>
            } 
          </Tab>
          <Tab eventKey="tabPorMes" title="Pesquisar por período" style={TAB}>
            <Row>
              <Col md="6" sm="12">        
                <Row>
                  <Col md="6" sm="12">
                    <DateRangePicker
                      appearance="default"
                      placeholder="Selecione o período"
                      style={{width: "100%"}}
                      format="DD-MM-YYYY"
                      onChange={value => {this.setState({periodoSelecionado: value})}}
                      locale={{
                        sunday: "Dom",
                        monday: "Seg",
                        tuesday: "Ter",
                        wednesday: "Qua",
                        thursday: "Qui",
                        friday: "Sex",
                        saturday: "Sáb",
                        ok: "Selecionar",
                        today: "Hoje",
                        yesterday: "Ontem",
                        last7Days: "Últimos 7 dias"
                      }}
                    />
                </Col>
                  <Col md="6" sm="12"><Select name="selectUsuarios" options={this.state.selectUsuarios} onChange={(e) => {this.setState({usuarioSelecionado: e.label})}} placeholder="Digite o nome do designer"/></Col>
                </Row>
              <Row>
                <Col sm="12"><label><input type="checkbox" checked={this.state.ignorarAlphaE} onChange={(e) => {this.setState({ignorarAlphaE: e.target.checked})}}/>{' '}Trazer somente contratos Alpha-e</label></Col>
              </Row>
              </Col>
              <Col md="6" sm="12">
                <Row>
                  <Col md="4" sm="12"><button onClick={this.handleChangePeriodo.bind(this)} className="btn btn-block btn-primary"><i className="fa fa-search"/></button></Col>
                  <Col md="4">{this.state.carregando ? <i className="fa fa-spinner fa-pulse fa-2x"/> : null}</Col>
                </Row>
              </Col>
            </Row>
            {
              !this.state.exibirGraficosPorPeriodo ?
                null
              : 
              <div>
                <br/>
                <Row>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Contratos avaliados</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.contratosAvaliados}</CardBody>
                    </Card>
                  </Col>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Capas avaliadas</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.countPublicacoes.capaDura}</CardBody>
                    </Card>
                  </Col>
                  <Col md="3" xs="6">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Paginações avaliadas</CardTitle>
                      <CardBody style={CARDNUMBER}>{this.state.countPublicacoes.paginacao}</CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de layout (capa e miolo)</CardTitle>
                      <CardBody><PieGraph data={this.state.notaGeral}/></CardBody>
                    </Card>
                  </Col>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de atendimento</CardTitle>
                      <CardBody><PieGraph data={this.state.notaAtendimento}/></CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de paginação</CardTitle>
                      <CardBody><DoughnutGraph data={this.state.notaPaginacao}/></CardBody>
                    </Card>
                  </Col>
                  <Col sm="4" xs="12">
                    <Card style={CARD}>
                      <CardTitle style={CARDTITLE}>Avaliações de capa dura</CardTitle>
                      <CardBody><DoughnutGraph data={this.state.notaCapadura}/></CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <TablePublicacoes contratos={this.props.contratos} isContract={true} designer={this.state.usuarioSelecionado.label}/>
                  </Col>
                </Row>              
              </div>
            }
          </Tab>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: {autenticado: state.usuario.autenticado, todos: state.usuario.todos},
    contratos: state.contrato.todos
  }
}

export default connect(mapStateToProps, {obterUsuariosVinculadosAoMetrics, obterPesquisasDeSatisfacao, obterPesquisasDeSatisfacaoPeloContrato, obterPesquisasDeSatisfacaoPeloPeriodo})(PesquisaSatisfacao);


// WEBPACK FOOTER //
// ./src/views/PesquisaSatisfacao.js